import React from 'react';

const Header = () => {
  return (
    <div className="header">
      <div className="logo">
      MovieComp
      </div>
      <div className="desc">
        It's easy, pick two movies, see which made more!
      </div>
    </div>
  )
}


export default Header;